// @ts-expect-error for 'module not installed' complaint on CallRecordsResource
import CallRecordsResource from 'flow/api/callrecords';
import Actions from 'flow/actions';
import { httpGetErrorDispatcher } from 'flow/actions/app-actions';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { AppDispatch } from 'flow/types/Redux';
import { State } from 'flow/types/State';
import { Callback } from 'flow/types/HomeClient';

/**
 * Fetch call records for an AI Coworker extension
 *
 * @param extensionKey - The AI Coworker extension key
 * @param include - Optional flags to include additional data (e.g., ['contact', 'apps'])
 * @param fromDate - Optional start date for filtering (timestamp in milliseconds)
 * @param toDate - Optional end date for filtering (timestamp in milliseconds)
 * @param otherPart - Optional phone number to filter calls with a specific party
 */
const includeFlagsDefault = [
    'contact',
    'recordings',
    'voicemessages',
    'apps',
    'all',
];

export const fetchCallRecordsForAICoworker =
    (
        extensionKey: ExtensionKey,
        include?: string | string[],
        fromDate?: number,
        toDate?: number,
        otherPart?: string,
    ) =>
    (dispatch: AppDispatch, _getState: () => State): Promise<void> => {
        include = include || includeFlagsDefault;
        const requestParams =
            include && Array.isArray(include) ? include.join() : include;

        return new Promise((resolve, reject) => {
            CallRecordsResource.getExtensionCallRecords(
                {
                    onResult(json) {
                        if (otherPart) {
                            dispatch(
                                receiveCallRecordsForNumber(
                                    extensionKey,
                                    otherPart,
                                    json,
                                ),
                            );
                        } else {
                            dispatch(receiveCallRecords(extensionKey, json));
                        }
                        resolve();
                    },
                    onError: (error) => {
                        httpGetErrorDispatcher();
                        reject(error);
                    },
                } as Callback,
                extensionKey,
                toDate,
                fromDate,
                otherPart,
                requestParams,
            );
        });
    };

const receiveCallRecords = (extensionKey: ExtensionKey, json: unknown) => ({
    type: Actions.RESULT_CALL_RECORDS_FETCHED,
    scope: { type: 'extension' as const, key: extensionKey },
    data: json,
});

const receiveCallRecordsForNumber = (
    extensionKey: ExtensionKey,
    otherPart: string,
    json: unknown,
) => ({
    type: Actions.RESULT_CALL_RECORDS_FETCHED,
    scope: {
        type: 'extension' as const,
        key: extensionKey,
        phoneNumber: otherPart,
    },
    data: json,
});
